// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"aa060d5c","120":"fa57dfb4","132":"519e4d85","195":"bb485a9a","240":"5a233e93","566":"1b1c15a6","833":"6d2f5df8","910":"237cb5be","962":"e2202374"}[chunkId] + ".chunk.js";
};